import { GField, GObjectType, GInputType } from "../graphql";

import { CoordinatesRecord } from "./CoordinatesRecord";

@GObjectType("UserSharedPosition")
@GInputType("UserSharedPositionInput")
export class UserSharedPosition {
  @GField(() => [CoordinatesRecord])
  public coordinates: CoordinatesRecord[] = [];

  @GField()
  public trackingEnabled: boolean;
}
